"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var core_1 = require("@material-ui/core");
var react_router_dom_1 = require("react-router-dom");
var connected_react_router_1 = require("connected-react-router");
var classnames_1 = __importDefault(require("classnames"));
var translate_1 = __importDefault(require("../../../../app/localization/translate"));
var icons_1 = require("../../../../common/icons");
var urls_1 = __importDefault(require("../../../../app/urls"));
var dateUtils_1 = require("../../../../youwell-common/dateUtils");
var store_1 = require("../../../../app/store");
var arrayUtils_1 = require("../../../../youwell-common/arrayUtils");
var utils_1 = require("../utils");
var components_1 = require("../../../../common/components");
var useStyles = (0, core_1.makeStyles)(function (theme) {
    var _a, _b, _c, _d, _e, _f;
    return ({
        modalContent: (_a = {},
            _a[theme.breakpoints.down('xs')] = {
                margin: theme.spacing(2, 1),
            },
            _a),
        header: {
            borderLeft: theme.youwell.borders.secondary,
            borderLeftWidth: 4,
            paddingLeft: theme.spacing(2),
        },
        headerTitle: {
            fontWeight: 500,
        },
        infoSection: (_b = {
                marginBottom: theme.spacing(2)
            },
            _b[theme.breakpoints.down('xs')] = {
                marginBottom: theme.spacing(0),
            },
            _b),
        infoSectionText: {
            margin: theme.spacing(0, 0, 2, 2),
        },
        infoSectionTextCaption: {
            fontWeight: 500,
        },
        importanceOfRegistrationInfoText: {
            marginTop: theme.spacing(2),
        },
        standaloneButtons: {
            display: 'flex',
            flexWrap: 'wrap',
        },
        registerButtons: (_c = {
                display: 'inline-block',
                marginTop: theme.spacing(2)
            },
            _c[theme.breakpoints.down('xs')] = {
                width: '100%',
            },
            _c),
        registerButtonsWrapper: (_d = {
                display: 'flex',
                flexWrap: 'wrap'
            },
            _d[theme.breakpoints.down('xs')] = {
                justifyContent: 'center',
            },
            _d),
        missingNightCard: (_e = {
                padding: theme.spacing(3, 2),
                margin: theme.spacing(1),
                width: 200,
                borderRadius: theme.youwell.shapes.borderRadiusFlatter
            },
            _e[theme.breakpoints.down('sm')] = {
                width: 180,
            },
            _e[theme.breakpoints.down('xs')] = {
                width: 260,
            },
            _e),
        lastCard: {
            WebkitMaskImage: '-webkit-gradient(linear, left top, right top, from(rgba(0,0,0,1)), to(rgba(0,0,0,0.3)))',
        },
        missingCardFlexWrapper: {
            display: 'flex',
        },
        missingCardTextFlexWrapper: {
            display: 'flex',
            flexDirection: 'column',
            textTransform: 'capitalize',
        },
        nightText: {
            textTransform: 'capitalize',
        },
        btnSection: (_f = {
                display: 'flex',
                justifyContent: 'flex-end',
                marginTop: theme.spacing(1),
                padding: theme.spacing(1)
            },
            _f[theme.breakpoints.down('xs')] = {
                justifyContent: 'center',
            },
            _f),
        notNowBtn: {
            padding: theme.spacing(2, 6),
            minWidth: 196,
            borderRadius: 40,
            background: theme.palette.common.white,
            '&:hover': {
                background: theme.palette.common.white,
            },
        },
        addIcons: {
            fontSize: 40,
            marginRight: theme.spacing(2),
        },
        registerSleep: {
            width: '100%',
            padding: theme.spacing(6),
        },
        registerSleepFlexWrapper: {
            display: 'flex',
        },
        registerSleepBtnText: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            marginLeft: theme.spacing(2),
        },
        registerSleepBtnCaption: {
            textTransform: 'initial',
            textAlign: 'left',
        },
    });
}, { name: 'RegisterSleepMenu' });
var RegisterSleepMenu = function (_a) {
    var isModal = _a.isModal, onClick = _a.onClick, numberOfNightCards = _a.numberOfNightCards;
    var translate = (0, translate_1.default)();
    var classes = useStyles();
    var dispatch = (0, store_1.useYouwellDispatch)();
    var _b = React.useState(false), showSleepMenu = _b[0], setShowSleepMenu = _b[1];
    var sleepEntries = (0, store_1.useYouwellSelector)(function (state) { return (0, arrayUtils_1.sortByDateAscending)(state.sleepDataStore.entries, 'date') || []; });
    var sleepLookup = (0, utils_1.getSleepLookup)(sleepEntries);
    var missingNights = (0, utils_1.missingRegistrationsLastWeek)(sleepLookup);
    var goToLogDay = function (night) {
        if (onClick) {
            onClick();
        }
        dispatch((0, connected_react_router_1.push)("".concat(urls_1.default.inside.pages.sleepDiary, "/log/").concat(night)));
    };
    var closeMenu = function () {
        setShowSleepMenu(false);
    };
    return (React.createElement(React.Fragment, null, isModal ? (React.createElement(React.Fragment, null,
        (missingNights === null || missingNights === void 0 ? void 0 : missingNights.length) > 0 && (React.createElement(core_1.Button, { className: classes.registerSleep, variant: "contained", color: "primary", onClick: function () { return setShowSleepMenu(true); } },
            React.createElement("div", { className: classes.registerSleepFlexWrapper },
                React.createElement(icons_1.AddIcon, { className: classes.addIcons }),
                React.createElement("div", { className: classes.registerSleepBtnText },
                    React.createElement(core_1.Typography, { variant: "h6" }, translate('sleepDiary.registerSleep')),
                    React.createElement(core_1.Typography, { className: classes.registerSleepBtnCaption, variant: "body2" }, (missingNights === null || missingNights === void 0 ? void 0 : missingNights.length) > 1
                        ? "".concat(missingNights === null || missingNights === void 0 ? void 0 : missingNights.length, " ").concat(translate('sleepDiary.missingRegistrations'), " ")
                        : "".concat(translate('sleepDiary.missingRegistration'))))))),
        React.createElement(components_1.OverlayModal, { open: showSleepMenu && (missingNights === null || missingNights === void 0 ? void 0 : missingNights.length) > 0, onClose: closeMenu },
            React.createElement("div", { className: classes.modalContent },
                React.createElement("div", { className: classes.header },
                    React.createElement(core_1.Typography, { variant: "h5", className: classes.headerTitle }, translate('sleepDiary.registerSleep')),
                    React.createElement(core_1.Typography, { className: classes.infoSectionTextCaption, variant: "body1" }, (missingNights === null || missingNights === void 0 ? void 0 : missingNights.length) > 1
                        ? "".concat(missingNights.length, " ").concat(translate('sleepDiary.missingRegistrations'), " ")
                        : "".concat(translate('sleepDiary.missingRegistration'), " "))),
                React.createElement("div", { className: classes.infoSection },
                    React.createElement("div", { className: classes.infoSectionText },
                        React.createElement(core_1.Typography, { className: classes.importanceOfRegistrationInfoText }, translate('sleepDiary.yourRegistrationIsImportantToUs')),
                        missingNights && missingNights.length === 1 ? (React.createElement(core_1.Typography, null, translate('sleepDiary.easyToForgetDetailsOneNight'))) : (React.createElement(core_1.Typography, null, translate('sleepDiary.easyToForgetDetails'))))),
                React.createElement("div", { className: classes.registerButtons },
                    React.createElement("div", { className: classes.registerButtonsWrapper }, missingNights === null || missingNights === void 0 ? void 0 : missingNights.slice(0, numberOfNightCards).map(function (night, i) {
                        var _a;
                        var _b;
                        return (React.createElement(core_1.Button, { key: night, className: (0, classnames_1.default)(classes.missingNightCard, (_a = {}, _a[classes.lastCard] = i === numberOfNightCards - 1, _a)), variant: "contained", color: i ? 'primary' : 'secondary', component: react_router_dom_1.Link, to: "".concat(urls_1.default.inside.pages.sleepDiary, "/log/").concat(night) },
                            React.createElement("div", { className: classes.missingCardFlexWrapper },
                                React.createElement(icons_1.AddIcon, { className: classes.addIcons }),
                                React.createElement("div", { className: classes.missingCardTextFlexWrapper },
                                    React.createElement(core_1.Typography, { variant: "h6" }, (0, dateUtils_1.datestamp)(night)),
                                    React.createElement(core_1.Typography, { variant: "body1", color: i ? 'secondary' : 'primary', className: classes.nightText }, "".concat(translate("time.weekdays_short.".concat((_b = (0, dateUtils_1.getLocalDate)(night)) === null || _b === void 0 ? void 0 : _b.getDay())), "."))))));
                    })),
                    React.createElement("div", { className: classes.btnSection },
                        React.createElement(core_1.Button, { className: classes.notNowBtn, variant: "outlined", color: "secondary", onClick: closeMenu }, translate('sleepDiary.notNow')))))))) : (React.createElement("div", { className: classes.standaloneButtons }, missingNights === null || missingNights === void 0 ? void 0 : missingNights.slice(0, numberOfNightCards).map(function (night, i) {
        var _a;
        var _b;
        return (React.createElement(core_1.Button, { key: night, className: (0, classnames_1.default)(classes.missingNightCard, (_a = {}, _a[classes.lastCard] = i === numberOfNightCards - 1, _a)), variant: "contained", color: "primary", onClick: function () { return goToLogDay(night); } },
            React.createElement("div", { className: classes.missingCardFlexWrapper },
                React.createElement(icons_1.AddIcon, { className: classes.addIcons }),
                React.createElement("div", { className: classes.missingCardTextFlexWrapper },
                    React.createElement(core_1.Typography, { variant: "h6" }, (0, dateUtils_1.datestamp)(night)),
                    React.createElement(core_1.Typography, { variant: "body1", color: i ? 'secondary' : 'primary', className: classes.nightText }, "".concat(translate("time.weekdays_short.".concat((_b = (0, dateUtils_1.getLocalDate)(night)) === null || _b === void 0 ? void 0 : _b.getDay())), "."))))));
    })))));
};
RegisterSleepMenu.defaultProps = {
    isModal: false,
    onClick: null,
};
exports.default = RegisterSleepMenu;
